<template
  ><div class="autocomplete form-field form-group">
    <div class="flex-autocomplete-field">
      <div class="autocomplete-text">
        <select :tabindex="tabindex" v-model="formData[propID]" :class="dropdownColorClass" :disabled="disabled">
          <option
            v-for="option in dataSource"
            v-bind:key="option.severityId"
            :class="option.color"
            :value="option.severityId"
            :selected="formData[propID] === option.severityId"
          >
            &nbsp;&nbsp;&nbsp;&nbsp;
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeverityDropdown',
  computed: {
    dataSource() {
      return this.$store.state.AutoCompletes.Severity.dataSource;
    },
    dropdownColorClass() {
      const dataSource = this.$store.state.AutoCompletes.Severity.dataSource;
      if(dataSource?.length){
        return `${dataSource.find(
          severity => severity.severityId === parseInt(this.formData[this.propID])
        )?.color || 'white'}`;
      }
      return 'white;'
    }
  },
  props: {
    formData: {
      type: Object
    },
    propID: {
      type: String
    },
    tabindex: {
      type: Number,
      default() {
        return 0;
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.autocomplete-text {
  padding: 2px 4px 2px 4px;
  select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
    width: 30px;
    height: 28px;
    border: none;
    border-radius: 2px;
  }
  /* For IE10 */
  select::-ms-expand {
    display: none;
  }
  .blue {
    background: $reportable-color;
  }
  .yellow {
    background: $abnormal-color;
  }
  .red {
    background: $critical-color;
  }
  .white {
    background: $white;
  }
}
</style>
